import React, { useMemo, useState, useEffect } from "react";
import Select from "react-select";
import { compareAsc, format, addMonths, isValid } from "date-fns";
import $ from "jquery";

const RequestTeamForm = () => {
  let SERVER_URL = process.env.REACT_APP_API_URL;
  let BASE_URL = process.env.REACT_APP_APP_URL;
  let token = JSON.parse(localStorage.getItem("key"));

  const [formData, setFormData] = useState({
    profile_details: "",
    comp_id: "",
    project_id: "",
    vertical: "",
    department: "",
    priority: "",
    location: "",
    no_requirement: "",
    skills: [],
    exp_min: "",
    exp_max: "",
    budget_month: "",
    budget_annum: "",
    position_open_date: "",
    hiring_type: "",
    replacement_for: "",
    working_mode: "",
    remarks: "",
  });
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("Open");
  const [loading, setLoading] = useState(false);
  const [Clientdata, setClientdata] = useState([]);
  const [Projectdata, setProjectdata] = useState([]);
  const [Verticaldata, setVerticaldata] = useState([]);
  const [departmentdata, setDepartmentData] = useState([]);
  const [skillData, setSkillData] = useState([]);

  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedVertical, setSelectedVertical] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState([]);

  const [loadingClient, setLoadingClient] = useState(false);
  const [loadingProject, setLoadingProject] = useState(false);
  const [loadingVertical, setLoadingVertical] = useState(false);
  const [loadingDepartment, setLoadingDepartment] = useState(false);
  const [loadingSkills, setLoadingSkills] = useState(false);

  // =========================================================
  // Get Vertical List
  // =========================================================

  useEffect(() => {
    getDepartmentList();
    getProjectList();
    getClientList();
  }, []);

  const getDepartmentList = async () => {
    try {
      setLoadingVertical(true);

      const response = await fetch(
        SERVER_URL + "api/common/department_group_list",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            authorization: `bearer ${token?.value}`,
          },
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP Error: ${response.status}`);
      }

      const data = await response.json();

      setVerticaldata(data?.result || []);
    } catch (error) {
      console.error("Error fetching vertical list:", error);
    } finally {
      setLoadingVertical(false);
    }
  };
  const getClientList = async () => {
    try {
      setLoadingClient(true);

      const response = await fetch(SERVER_URL + "api/common/company_list", {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          authorization: `bearer ${token?.value}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP Error: ${response.status}`);
      }

      const data = await response.json();

      setClientdata(data?.result || []);
    } catch (error) {
      console.error("Error fetching Client list:", error);
    } finally {
      setLoadingClient(false);
    }
  };
  const getProjectList = async () => {
    try {
      setLoadingProject(true);

      const response = await fetch(SERVER_URL + "api/common/project_list", {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          authorization: `bearer ${token?.value}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP Error: ${response.status}`);
      }

      const data = await response.json();

      setProjectdata(data?.result || []);
    } catch (error) {
      console.error("Error fetching Project list:", error);
    } finally {
      setLoadingProject(false);
    }
  };

  // =========================================================
  // Client Options
  // =========================================================

  const Client_option = useMemo(() => {
    return (
      Clientdata?.map((row) => ({
        value: row.id,
        label: row.name,
      })) || []
    );
  }, [Clientdata]);
  // =========================================================
  // Project Options
  // =========================================================

  const Project_option = useMemo(() => {
    return (
      Projectdata?.map((row) => ({
        value: row.id,
        label: row.project_name,
      })) || []
    );
  }, [Projectdata]);
  // =========================================================
  // Vertical Options
  // =========================================================

  const Vertical_option = useMemo(() => {
    return (
      Verticaldata?.map((row) => ({
        group_id: row.group_id,
        value: row.id,
        label: row.name,
      })) || []
    );
  }, [Verticaldata]);
  // =========================================================
  // Department Options
  // =========================================================

  const department_option = useMemo(() => {
    return (
      departmentdata?.map((row) => ({
        value: row.id,
        label: row.name,
      })) || []
    );
  }, [departmentdata]);

  // =========================================================
  // Skill Options Based On Selected Vertical
  // =========================================================

  const Skill_options = useMemo(() => {
    if (!selectedDepartment) {
      return [];
    }

    return (
      skillData
        ?.filter(
          (skill) =>
            Number(skill.group_id) === Number(selectedDepartment?.value),
        )
        .map((skill) => ({
          value: skill.id,
          label: skill.name,
        })) || []
    );
  }, [skillData]);
  // =========================================================
  // Client Change
  // =========================================================
  const handleClientChange = async (selectedOption) => {
    console.log("Selected Client:", selectedOption);
    setSelectedClient(selectedOption);
    setFormData((prev) => ({
      ...prev,
      comp_id: selectedOption?.value || "",
    }));
  };

  // =========================================================
  // Project Change
  // =========================================================
  const handleProjectChange = async (selectedOption) => {
    console.log("Selected Project:", selectedOption);
    setSelectedProject(selectedOption);
    setFormData((prev) => ({
      ...prev,
      project_id: selectedOption?.value || "",
    }));
  };
  // =========================================================
  // Vertical Change
  // =========================================================

  const handleVerticalChange = async (selectedOption) => {
    console.log("Selected Vertical:", selectedOption);

    // Set selected vertical
    setSelectedVertical(selectedOption);

    // Clear previous department
    setSelectedDepartment([]);
    setDepartmentData([]);

    // Clear previous skills
    setSelectedSkills([]);
    setSkillData([]);

    // Update formData
    setFormData((prev) => ({
      ...prev,
      vertical: selectedOption?.value || "",
      department: [],
      skills: [],
    }));

    if (!selectedOption) {
      return;
    }

    const verticalId = selectedOption.value;

    console.log("Sending Vertical ID:", verticalId);

    try {
      setLoadingDepartment(true);

      const response = await fetch(
        SERVER_URL + `api/common/getDepartmentGroupList?id=${verticalId}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            authorization: `bearer ${token.value}`,
          },
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP Error: ${response.status}`);
      }

      const data = await response.json();

      console.log("Department API Response:", data);
      console.log("Department API Result:", data?.data);

      setDepartmentData(data?.data || []);
    } catch (error) {
      console.error("Department error:", error);
      setDepartmentData([]);
    } finally {
      setLoadingDepartment(false);
    }
  };
  // =========================================================
  // Department Change
  // =========================================================

  const handleDepartmentChange = async (selectedOption2) => {
    console.log("Selected Department:", selectedOption2);

    // Set selected Department
    setSelectedDepartment(selectedOption2);

    // Clear previous skills
    setSelectedSkills([]);
    setSkillData([]);

    // Update formData
    setFormData((prev) => ({
      ...prev,
      department: selectedOption2?.value || "",
      skills: [],
    }));

    if (!selectedOption2) {
      return;
    }

    const departmentId = selectedOption2.value;

    console.log("Sending Department ID:", departmentId);

    try {
      setLoadingSkills(true);

      const response = await fetch(
        SERVER_URL + `api/common/getSkillGroupList?vertical_id=${departmentId}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            authorization: `bearer ${token.value}`,
          },
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP Error: ${response.status}`);
      }

      const data = await response.json();

      console.log("Skill API Response:", data);
      console.log("Skill API Result:", data?.data);

      setSkillData(data?.data || []);
    } catch (error) {
      console.error("Skill error:", error);
      setSkillData([]);
    } finally {
      setLoadingSkills(false);
    }
  };
  // =========================================================
  // Skill Change
  // =========================================================

  const handleSkillChange = (selectedOptions) => {
    const skills = selectedOptions || [];

    console.log("Selected Skills:", skills);

    // Update Select value
    setSelectedSkills(skills);

    // Update formData
    setFormData((prev) => ({
      ...prev,
      skills: skills.map((skill) => skill.value),
    }));
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Automatically calculate annual budget
    if (name === "budget_month") {
      const monthly = Number(value || 0);

      setFormData((prev) => ({
        ...prev,
        budget_month: value,
        budget_annum: monthly * 12,
      }));
    }

    // Remove error for this field
    if (errors[name]) {
      setErrors((prev) => {
        const updatedErrors = { ...prev };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };
  // =====================================================
  // VALIDATE FORM
  // =====================================================

  const validateForm = () => {
    const newErrors = {};
    console.log(formData, "formData validation=================error");
    // Profile Details
    if (!formData.profile_details?.trim()) {
      newErrors.profile_details = "Profile Details is required";
    }

    // Company
    if (!formData.comp_id) {
      newErrors.comp_id = "Company is required";
    }

    // Project
    if (!formData.project_id) {
      newErrors.project_id = "Project Name is required";
    }

    // Vertical
    if (!formData.vertical) {
      newErrors.vertical = "Vertical is required";
    }

    // Department
    if (!formData.department) {
      newErrors.department = "Department is required";
    }

    // Skills
    if (!formData.skills || formData.skills.length === 0) {
      newErrors.skills = "Skills is required";
    }

    // Priority
    if (!formData.priority) {
      newErrors.priority = "Priority is required";
    }

    // No Requirement
    if (!formData.no_requirement) {
      newErrors.no_requirement = "No. Of Requirement is required";
    }

    // Location
    if (!formData.location?.trim()) {
      newErrors.location = "Location is required";
    }

    // Position Open Date
    if (!formData.position_open_date) {
      newErrors.position_open_date = "Position Open Date is required";
    }

    setErrors(newErrors);

    return newErrors;
  };

  // =====================================================
  // FOCUS FIRST ERROR FIELD
  // =====================================================
  const focusFirstError = (errors) => {
    const firstError = Object.keys(errors)[0];

    if (!firstError) {
      return;
    }

    // =====================================================
    // SELECT2 / SKILLS
    // =====================================================

    if (firstError === "skills") {
      const select = document.querySelector('select[name="skills"]');

      if (select) {
        const select2Container = $(select).next(".select2");

        // Red border
        select2Container.find(".select2-selection").addClass("select2-error");

        // Scroll
        select2Container[0]?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });

        // Focus + open Select2
        setTimeout(() => {
          $(select).select2("open");
        }, 400);

        return;
      }
    }

    // =====================================================
    // NORMAL INPUT / TEXTAREA / SELECT
    // =====================================================

    const field = document.querySelector(`[name="${firstError}"]`);

    if (field) {
      field.classList.add("is-invalid");

      field.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });

      setTimeout(() => {
        field.focus();
      }, 400);
    }
  };

  // =====================================================
  // HANDLE SUBMIT
  // =====================================================
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Remove old Select2 error
    $(".select2-selection").removeClass("select2-error");

    // Validate
    const validationErrors = validateForm();

    // If validation failed
    if (Object.keys(validationErrors).length > 0) {
      focusFirstError(validationErrors);
      return;
    }

    try {
      setLoading(true);
      const date = new Date();
      const date_formate = format(date, "yyyy-MM-dd HH:m:ss");
      const userId = localStorage.getItem("userId");

      const payload = {
        ...formData,
        created_by: userId,
        created_at: date_formate,
      };

      console.log(payload, "FINAL PAYLOAD====================");

      const response = await fetch(SERVER_URL + "api/requestTeam/create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `bearer ${token.value}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.message || "Something went wrong while saving the request",
        );
      }

      alert(data.message || "Request created successfully");

      // Clear errors
      setErrors({});

      // Reset form
      setFormData({
        profile_details: "",
        comp_id: "",
        project_id: "",
        vertical: "",
        department: "",
        skills: [],
        priority: "",
        no_requirement: "",
        location: "",
        position_open_date: "",
        exp_min: "",
        exp_max: "",
        budget_month: "",
        budget_annum: "",
        hiring_type: "",
        replacement_for: "",
        working_mode: "",
        remarks: "",
      });

      // Clear Select2
      $("#skills").val(null).trigger("change");
    } catch (error) {
      console.error(error);

      alert(error.message || "Something went wrong while saving the request");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="container-fluid py-4">
      <div className="card shadow-sm border-0">
        {/* Header */}
        <div className="card-header bg-white border-bottom">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h4 className="mb-1">Request Team</h4>
              <p className="text-muted mb-0">Define the hiring requirement</p>
            </div>

            <span className="badge bg-success px-3 py-2">Status: {status}</span>
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="card-body">
            {/* Profile Details */}
            <div className="section-title">
              <h5>Profile Details</h5>
            </div>

            <div className="row g-3">
              <div className="col-md-12">
                <label className="form-label">
                  Profile Details <span className="text-danger">*</span>
                </label>

                <textarea
                  name="profile_details"
                  value={formData.profile_details}
                  onChange={handleChange}
                  required
                  className={`form-control ${
                    errors.profile_details ? "is-invalid" : ""
                  }`}
                  placeholder="Enter profile / job requirement details"
                  rows="3"
                />

                {errors.profile_details && (
                  <div className="invalid-feedback">
                    {errors.profile_details}
                  </div>
                )}
              </div>
              {/* Company */}
              <div className="col-md-4">
                <label className="form-label">
                  Company <span className="text-danger">*</span>
                </label>
                <Select
                  name="comp_id"
                  options={Client_option}
                  value={selectedClient}
                  onChange={handleClientChange}
                  placeholder="Select Company"
                  isSearchable
                  isClearable
                  required
                  isLoading={loadingClient}
                />
              </div>
              {/* Project Name */}
              <div className="col-md-4">
                <label className="form-label">
                  Project Name <span className="text-danger">*</span>
                </label>
                <Select
                  name="project_id"
                  options={Project_option}
                  value={selectedProject}
                  onChange={handleProjectChange}
                  placeholder="Select Project"
                  isSearchable
                  isClearable
                  required
                  isLoading={loadingProject}
                />
              </div>

              {/* Vertical */}
              <div className="col-md-4">
                <label className="form-label">
                  Vertical <span className="text-danger">*</span>
                </label>
                <Select
                  name="vertical"
                  options={Vertical_option}
                  value={selectedVertical}
                  onChange={handleVerticalChange}
                  placeholder="Select Vertical"
                  isSearchable
                  isClearable
                  required
                  isLoading={loadingVertical}
                />
              </div>
              {/* Vertical */}
              <div className="col-md-4">
                <label className="form-label">
                  Department <span className="text-danger">*</span>
                </label>
                <Select
                  name="department"
                  options={department_option}
                  value={selectedDepartment}
                  onChange={handleDepartmentChange}
                  placeholder="Select Department"
                  isSearchable
                  isClearable
                  required
                  isLoading={loadingDepartment}
                />
              </div>
              {/* Skills */}
              <div className="col-md-4">
                <label className="form-label">
                  Skills <span className="text-danger">*</span>
                </label>

                <Select
                  name="skills"
                  options={Skill_options}
                  value={selectedSkills}
                  onChange={handleSkillChange}
                  placeholder={
                    selectedVertical
                      ? "Search and select skills..."
                      : "First select vertical"
                  }
                  isMulti
                  isSearchable
                  isClearable
                  required
                  isDisabled={!selectedVertical}
                  isLoading={loadingSkills}
                  closeMenuOnSelect={false}
                  noOptionsMessage={() =>
                    selectedVertical
                      ? "No skills available"
                      : "Select vertical first"
                  }
                />

                <small className="text-muted">
                  Separate multiple skills using comma
                </small>
              </div>
              {/* Priority */}
              <div className="col-md-4">
                <label className="form-label">
                  Priority <span className="text-danger">*</span>
                </label>

                <select
                  className="form-select"
                  name="priority"
                  value={formData.priority}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Priority</option>
                  <option value="Low">Low</option>
                  <option value="Medium">Medium</option>
                  <option value="High">High</option>
                  <option value="Critical">Critical</option>
                </select>
              </div>
              {/* Reqirement */}
              <div className="col-md-4">
                <label className="form-label">
                  No. Of Requirement <span className="text-danger">*</span>
                </label>

                <input
                  type="text"
                  className="form-control"
                  name="no_requirement"
                  placeholder="e.g. 1"
                  value={formData.no_requirement}
                  onChange={handleChange}
                  required
                />
              </div>
              {/* Location */}
              <div className="col-md-4">
                <label className="form-label">
                  Location <span className="text-danger">*</span>
                </label>

                <input
                  type="text"
                  className="form-control"
                  name="location"
                  placeholder="e.g. Noida"
                  value={formData.location}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Position Open Date */}
              <div className="col-md-4">
                <label className="form-label">
                  Position Open Date <span className="text-danger">*</span>
                </label>

                <input
                  type="date"
                  className="form-control"
                  name="position_open_date"
                  value={formData.position_open_date}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Experience */}
              <div className="col-md-6">
                <label className="form-label">
                  Experience Range (Years){" "}
                  <span className="text-danger">*</span>
                </label>

                <div className="row">
                  <div className="col-6">
                    <input
                      type="number"
                      min="0"
                      className="form-control"
                      name="exp_min"
                      placeholder="Min"
                      value={formData.exp_min}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="col-6">
                    <input
                      type="number"
                      min="0"
                      className="form-control"
                      name="exp_max"
                      placeholder="Max"
                      value={formData.exp_max}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
              </div>
              {/* Hiring Type */}
              <div className="col-md-3">
                <label className="form-label">
                  Hiring Type <span className="text-danger">*</span>
                </label>

                <select
                  className="form-select"
                  name="hiring_type"
                  value={formData.hiring_type}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Hiring Type</option>
                  <option value="New Position">New Position</option>
                  <option value="Replacement">Replacement</option>
                  <option value="Contract">Contract</option>
                  <option value="Intern">Intern</option>
                </select>
              </div>
              {/* Replacement */}
              <div className="col-md-3">
                <label className="form-label">Replacement For</label>

                <input
                  type="text"
                  className="form-control"
                  name="replacement_for"
                  placeholder="Employee name / ID"
                  value={formData.replacement_for}
                  onChange={handleChange}
                />
              </div>

              {/* Budget */}
              <div className="col-md-6">
                <label className="form-label">
                  Budget / Month <span className="text-danger">*</span>
                </label>

                <div className="input-group">
                  <span className="input-group-text">₹</span>

                  <input
                    type="number"
                    min="0"
                    className="form-control"
                    name="budget_month"
                    placeholder="Monthly budget"
                    value={formData.budget_month}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              {/* Annual Budget */}
              <div className="col-md-6">
                <label className="form-label">Budget / Annum</label>

                <div className="input-group">
                  <span className="input-group-text">₹</span>

                  <input
                    type="number"
                    className="form-control bg-light"
                    name="budget_annum"
                    value={formData.budget_annum}
                    readOnly
                  />
                </div>

                <small className="text-muted">
                  Automatically calculated as Monthly Budget × 12
                </small>
              </div>

              {/* Working Mode */}
              <div className="col-md-6">
                <label className="form-label">
                  Working Mode <span className="text-danger">*</span>
                </label>

                <div className="d-flex gap-4 mt-2">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="working_mode"
                      value="Work From Office"
                      checked={formData.working_mode === "Work From Office"}
                      onChange={handleChange}
                    />

                    <label className="form-check-label">Work From Office</label>
                  </div>

                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="working_mode"
                      value="Hybrid"
                      checked={formData.working_mode === "Hybrid"}
                      onChange={handleChange}
                    />

                    <label className="form-check-label">Hybrid</label>
                  </div>

                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="working_mode"
                      value="Remote"
                      checked={formData.working_mode === "Remote"}
                      onChange={handleChange}
                    />

                    <label className="form-check-label">Remote</label>
                  </div>
                </div>
              </div>

              {/* Status */}
              <div className="col-md-6">
                <label className="form-label">Status</label>

                <input
                  type="text"
                  className="form-control bg-light"
                  value={status}
                  readOnly
                  disabled
                />

                <small className="text-muted">
                  Status is automatically linked from Hiring Team.
                </small>
              </div>

              {/* Remarks */}
              <div className="col-md-12">
                <label className="form-label">Remarks</label>

                <textarea
                  className="form-control"
                  name="remarks"
                  rows="3"
                  placeholder="Enter any additional remarks"
                  value={formData.remarks}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="card-footer bg-white d-flex justify-content-end gap-2">
            <button
              type="button"
              className="btn btn-light border"
              onClick={() => window.history.back()}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="btn btn-primary px-4"
              disabled={loading}
            >
              {loading ? "Saving..." : "Create Request"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RequestTeamForm;
